import { Injectable } from '@angular/core';
import * as global_var from '../global.variable';
import { Router, ActivatedRoute } from '@angular/router';
import { map, timeout } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  constructor(private http: HttpClient, private router: Router) {}

  getClientName(case_id) {
    return this.http.post(global_var.apiUrl + 'getcasename', case_id).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getPayrollFeature() {
    return this.http.post(global_var.apiUrl + 'payroll/feature', {}).pipe(
      map((res: any) => res)
    );
  }

  setHeader() {
    return this.http.post(global_var.apiUrl + 'setheader', {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
